import RichTextEditor from 'react-rte';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';

const styles = theme => ({

});

class CourseEnrollmentDescription extends Component {
    state = {
        rte_value: RichTextEditor.createValueFromString(this.props.course.CourseEnrollmentDescription, 'html')
    }

    onEditorStateChange = (rte_value) => {
        this.setState({ rte_value });
        const field_name = 'CourseEnrollmentDescription';
        const update_data = {
            [field_name]: rte_value.toString('html')
        }
        this.props.updateCourseForm(update_data);
    }

    

    render() {
        const { view_type } = this.props;

        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Underline', style: 'UNDERLINE' }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'Heading Large', style: 'header-one' },
                { label: 'Heading Medium', style: 'header-two' },
                { label: 'Heading Small', style: 'header-three' }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'UL', style: 'unordered-list-item' },
                { label: 'OL', style: 'ordered-list-item' },
            ],
        };

        return (
            <Grid container spacing={8}>
                <Grid item xs={4}>
                    <RichTextEditor
                        toolbarConfig={toolbarConfig}
                        value={this.state.rte_value}
                        onChange={this.onEditorStateChange}
                        className='h-full'
                        readOnly={view_type === 'detail'}
                        editorStyle={{ minHeight: '300px' }}
                    />
                </Grid>
            </Grid>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCourseForm: Actions.updateCourseForm,
    }, dispatch);
}

function mapStateToProps({ courseApp, auth }) {
    return {
        course: courseApp.courses.currentCourse,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseEnrollmentDescription)));



// WEBPACK FOOTER //
// src/main/content/course/CourseEnrollmentDescription.js